import MAIN from './main';
import BOOKMARK from './bookmark';
import { constants } from '../../../../../../utils/octopus';

const { OWNERSHIPS } = constants;

const BookmarkPlugin = {
  resolver: props => !!props.bookmark,
  definitions: {
    ...MAIN,
    ...BOOKMARK,
  },
  ownership: OWNERSHIPS.VPP,
  id: 'bookmarks',
  deps: ['bookmark'],
};

export default BookmarkPlugin;
